const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/prestations", {
	title: __("Prestations", "wp-apidae"), // Block title.
	description: __("Affiche les différentes prestations.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.checklist
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		equipements: {
			type: "boolean",
			default: true,
		},
		services: {
			type: "boolean",
			default: true,
		},
		conforts: {
			type: "boolean",
			default: true,
		},
		activites: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		ss_field_tag: {
			type: 'string',
			default: 'h3',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Equipements' ) }
								checked={ attributes.equipements }
								onChange={ () => {
									props.setAttributes({ equipements: ! attributes.equipements });
								} }
							/>
						<ToggleControl
								label={ __( 'Services' ) }
								checked={ attributes.services }
								onChange={ () => {
									props.setAttributes({ services: ! attributes.services });
								} }
							/>
							<ToggleControl
								label={ __( 'Conforts' ) }
								checked={ attributes.conforts }
								onChange={ () => {
									props.setAttributes({ conforts: ! attributes.conforts });
								} }
							/>
							<ToggleControl
								label={ __( 'Activités' ) }
								checked={ attributes.activites }
								onChange={ () => {
									props.setAttributes({ activites: ! attributes.activites });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<SelectControl
							label={ __( 'Balise des sous titres' ) }
							value={ attributes.ss_field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/prestations"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
